"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.agreementApproveApi = agreementApproveApi;
exports.agreementFeedbackDetailApi = agreementFeedbackDetailApi;
exports.agreementFeedbackDispositionApi = agreementFeedbackDispositionApi;
exports.agreementFeedbackListApi = agreementFeedbackListApi;
exports.agreementHistoryApi = agreementHistoryApi;
exports.agreementNoticeApi = agreementNoticeApi;
exports.agreementPublishApi = agreementPublishApi;
exports.agreementVersionCreateApi = agreementVersionCreateApi;
exports.agreementVersionDetailApi = agreementVersionDetailApi;
exports.agreementVersionDownloadApi = agreementVersionDownloadApi;
exports.agreementVersionUpdateApi = agreementVersionUpdateApi;
exports.agreementWithdrawApi = agreementWithdrawApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

var agreementVersionUrl = function agreementVersionUrl(type) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return "admin/platform/agreement/".concat(encodeURIComponent(type), "/versions").concat(version ? "/".concat(encodeURIComponent(version)) : '');
};
function agreementVersionCreateApi(type, data) {
  return (0, _request.default)({
    url: agreementVersionUrl(type),
    method: 'POST',
    data: data
  });
}
function agreementVersionUpdateApi(type, version, data) {
  return (0, _request.default)({
    url: agreementVersionUrl(type, version),
    method: 'PUT',
    data: data
  });
}
function agreementNoticeApi(type, version, data) {
  return (0, _request.default)({
    url: "".concat(agreementVersionUrl(type, version), "/notice"),
    method: 'POST',
    data: data
  });
}
function agreementApproveApi(type, version, data) {
  return (0, _request.default)({
    url: "".concat(agreementVersionUrl(type, version), "/approve"),
    method: 'POST',
    data: data
  });
}
function agreementPublishApi(type, version, data) {
  return (0, _request.default)({
    url: "".concat(agreementVersionUrl(type, version), "/publish"),
    method: 'POST',
    data: data
  });
}
function agreementWithdrawApi(type, version, data) {
  return (0, _request.default)({
    url: "".concat(agreementVersionUrl(type, version), "/withdraw"),
    method: 'POST',
    data: data
  });
}
function agreementHistoryApi(type, params) {
  return (0, _request.default)({
    url: "admin/platform/agreement/".concat(encodeURIComponent(type), "/history"),
    method: 'GET',
    params: params
  });
}
function agreementVersionDetailApi(type, version) {
  return (0, _request.default)({
    url: agreementVersionUrl(type, version),
    method: 'GET'
  });
}
function agreementVersionDownloadApi(type, version) {
  return (0, _request.default)({
    url: "".concat(agreementVersionUrl(type, version), "/download"),
    method: 'GET',
    responseType: 'blob'
  });
}
function agreementFeedbackListApi(params) {
  return (0, _request.default)({
    url: 'admin/platform/agreement/feedback',
    method: 'GET',
    params: params
  });
}
function agreementFeedbackDetailApi(id) {
  return (0, _request.default)({
    url: "admin/platform/agreement/feedback/".concat(encodeURIComponent(id)),
    method: 'GET'
  });
}
function agreementFeedbackDispositionApi(id, data) {
  return (0, _request.default)({
    url: "admin/platform/agreement/feedback/".concat(encodeURIComponent(id), "/disposition"),
    method: 'PUT',
    data: data
  });
}